import { SeriesLineOptions } from 'highcharts';
import { HistogramPointDefinition } from 'modules/graphql';
import { MetricIdentifier } from '../constants';
import {
  ExperimentHoldoutBreakdownDetail,
  ExperimentVariantBreakdownArray,
  ExperimentVariantBreakdownDetail,
} from '../types';
import { retrieveMetricResult } from './common';
import { isExperimentHoldoutRow } from './ruleEngine';

/**
 * Converts the graphQL metric data into Highchart readable data
 *
 * @param variants Custom experiment variants list
 * @param selectedMetric User selected metric on the variant performance chart
 * @returns SeriesLineOptions[]
 */
export const getTimeSeriesData = (
  variants: ExperimentVariantBreakdownArray,
  selectedMetric: string,
  metricMap: Record<string, MetricIdentifier>,
  holdoutLabel: string,
) =>
  (variants as [ExperimentVariantBreakdownDetail | ExperimentHoldoutBreakdownDetail]).reduce<
    SeriesLineOptions[]
  >((timeSeriesData, variant) => {
    const lineData: SeriesLineOptions = {
      type: 'line',
    };
    const metricHistogram =
      retrieveMetricResult({
        dataStore: variant,
        metricMap,
        metric: selectedMetric,
      })?.histogram ?? [];
    if (isExperimentHoldoutRow(variant)) {
      lineData.selected = false;
      lineData.name = holdoutLabel;
      lineData.data = metricHistogram;
    } else {
      lineData.selected = variant.control;
      lineData.name = variant.variantName;
      lineData.data = metricHistogram;
      // Control variant needs to be displayed first
      return variant?.control ? [lineData, ...timeSeriesData] : [...timeSeriesData, lineData];
    }

    // The holdout group will be the last variant
    return [...timeSeriesData, lineData];
  }, []);

export const highChartifyHistogram = (histogram: HistogramPointDefinition[] = []) =>
  histogram.map(({ time, value }) => [time, value]);
